import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

class Modal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showContainer: false
		};

		this.handleClick = this.handleClick.bind(this);
	}

	componentWillMount() {
		document.addEventListener('click', this.handleClick, false);
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClick, false);
	}

	handleClick(e) {
		if (this.node.contains(e.target)) {
			return false;
		}

		this.props.closeDialogClicked(e);
	}

	render() {
		const {
			styles,
			children,
			height,
			width,
			closeButton,
			closeDialogClicked
		} = this.props;

		const containerStyles = {
		    ...styles,
		    width: `${width}px`,
			height: `${height}px`,
			top: `calc(50% - ${height/2}px)`,
			left: `calc(50% - ${width/2}px)`,
		};

		return (
			<div className="Modal" style={styles}>
				<div
					style={containerStyles}
					className="Modal-container"
					ref={node => (this.node = node)}
				>
					{
						closeButton &&
                            <button onClick={closeDialogClicked} className="Modal-close">Close</button>
					}
					{
						children
					}
				</div>
			</div>
		);
	}
}

Modal.propTypes = {
	children: PropTypes.node,
	closeDialogClicked: PropTypes.func,
	styles: PropTypes.object,
	show: PropTypes.bool,
	width: PropTypes.number,
	height: PropTypes.number,
};

Modal.defaultProps = {
	show: false,
	width: 650,
	height: 300,
};

export default Modal;
